import React, {
  useEffect,
  useState
} from "react";
import HeaderForChat from "../../components/default/HeaderForChat";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import VimeoPlayer from "../../components/VimeoPlayer";
import StoriesService from "../../services/StoriesService";
import LoaderForPage from "../../components/LoaderForPage";

const PlayedVideo = () => {
  const params = useParams();
  const initialStory = StoriesService.getCachedStory(params.id);
  const [isLoading, setIsLoading] = useState(!initialStory);
  const [story, setStory] = useState(initialStory);

  const navigate = useNavigate();
  const videoID = parseInt(params.id);

  const handleVideoEnd = async () => {
    try {
      window.umami?.track('Video Watched', { videoID: params.id, videoOrder: story.order });
      const watchedStories = JSON.parse(localStorage.getItem("watchedStories") || "[]");
      if(!watchedStories.includes(videoID)) {
        watchedStories.push(videoID);
        localStorage.setItem("watchedStories", JSON.stringify(watchedStories));
      }
      navigate("/");
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    const cachedStory = StoriesService.getCachedStory(params.id);

    if (cachedStory) {
      setStory(cachedStory);
      setIsLoading(false);
    } else {
      setStory(null);
      setIsLoading(true);
    }

    let isMounted = true;

    (async () => {
      try {
        const storyResponse = await StoriesService.getStory(params.id);

        if (!isMounted || !storyResponse) {
          return;
        }

        setStory(storyResponse);
      } catch (error) {
        toast.error("Unable to load this story.");
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [params.id]);

  if(isLoading || !story) {
    return (
      <>
        <div className="">
          <HeaderForChat title={story?.title || ""} navigate="/" />
        </div>

        <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-4">
          <LoaderForPage />
        </div>
      </>
    )
  } else {
    return (
      <>
        <div className="">
          <HeaderForChat title={story?.title} navigate="/" />
        </div>

        <div>
          <VimeoPlayer
            video={story.url}
            title={story.title}
            autoplay
            onEnd={handleVideoEnd}
          />
        </div>
      </>
    );
  }

};

export default PlayedVideo;
